import { stateGo } from 'redux-ui-router';
import { PermissionService, SessionSelectors } from 'invision-core';
import { CurrentCustomerIdSelector, CurrentCustomerSelector, IsCurrentCustomerBlocklisted } from './../../../../reducers/selectors/customer.selectors';
import LocaleKeys from './../../../../locales/keys';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { searchSubscriptions, setCurrentPage, setIncludedFilter, setPageSizePreference } from './../../../../reducers/actions/customer.subscriptions.actions';
import { BriefSubscriptionsSelector, IncludeRemovedSelector, IsFetchingDataSelector, PageNumberSelector, RecordCountSelector, SelectedPageSizePreference, SubscriptionErrorSelector, TotalPagesSelector } from './../../../../reducers/selectors/customer.subscriptions.selectors';
import { CREATE_SUBSCRIPTIONS_ORDER_STATE_NAME } from '../../../../reducers/constants/products.wizard.constants';
import { ORDERING_ACCESS } from '../../../../security.attributes';
export var SORT_DESC = 2;
function SubscriptionsController($ngRedux, uiNotificationService) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      currentCustomerId: CurrentCustomerIdSelector(store),
      currentCustomer: CurrentCustomerSelector(store),
      includeRemoved: IncludeRemovedSelector(store),
      isCurrentCustomerBlocklisted: IsCurrentCustomerBlocklisted(store),
      isFetchingData: IsFetchingDataSelector(store),
      pagerCurrentPage: PageNumberSelector(store),
      pagerMaxSlots: 5,
      pagerNumPages: TotalPagesSelector(store),
      pagerPageSize: SelectedPageSizePreference(store) || SessionSelectors.PageSizePreferenceSelector(store),
      pagerRecordCount: RecordCountSelector(store),
      subscriptionError: SubscriptionErrorSelector(store),
      subscriptions: BriefSubscriptionsSelector(store),
      userSecurityAttributes: SessionSelectors.UserSecurityAttributesSelector(store)
    };
  };
  this.$onInit = function () {
    _this.uiNotificationService = uiNotificationService;
    var controllerActions = {
      searchSubscriptions: searchSubscriptions,
      setCurrentPage: setCurrentPage,
      setIncludedFilter: setIncludedFilter,
      setPageSizePreference: setPageSizePreference,
      stateGo: stateGo
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.LocaleKeys = LocaleKeys;
    _this.stateOrName = 'index.customercare.customer.subscriptions';
    _this.optionalParams = {
      customerId: _this.state.currentCustomerId
    };
    _this.fetchSubscriptions();
  };
  this.fetchSubscriptions = function () {
    var criteria = {
      IncludeRemoved: _this.state.includeRemoved,
      IncludePaymentInstrumentInfo: true,
      PageNumber: _this.state.pagerCurrentPage,
      PageSize: _this.state.pagerPageSize,
      SortDirection: SORT_DESC
    };
    return _this.actions.searchSubscriptions(_this.state.currentCustomerId, criteria).catch(function () {
      if (_this.state.subscriptionError) {
        _this.uiNotificationService.error(_this.state.subscriptionError.message, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      }
    });
  };
  this.handleIncludeRemovedClick = function () {
    _this.actions.setIncludedFilter(!_this.state.includeRemoved);
    _this.actions.setCurrentPage(1);
    _this.fetchSubscriptions();
  };
  this.hasOrderingAccess = function () {
    return PermissionService.hasAdminAccess(_this.state.userSecurityAttributes, ORDERING_ACCESS) && !_this.state.isCurrentCustomerBlocklisted;
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
  this.hasSubscriptions = function () {
    return _this.state.subscriptions.length > 0;
  };
  this.addSubscription = function () {
    _this.actions.stateGo(CREATE_SUBSCRIPTIONS_ORDER_STATE_NAME, {
      subscriptionsOnly: true
    });
  };
  this.updatePage = function (pageNum) {
    _this.actions.setCurrentPage(pageNum);
    _this.fetchSubscriptions();
  };
  this.updatePageSize = function (pageSize) {
    _this.actions.setPageSizePreference(pageSize);
    _this.actions.setCurrentPage(1);
    _this.fetchSubscriptions();
  };
}
export default {
  bindings: {},
  template: require('./subscriptions.list.html'),
  controller: SubscriptionsController,
  controllerAs: 'controller'
};